import script from "./Msg.vue?vue&type=script&setup=true&lang=ts"
export * from "./Msg.vue?vue&type=script&setup=true&lang=ts"

import "./Msg.vue?vue&type=style&index=0&id=19ae9546&lang=scss&scoped=true"

import exportComponent from "/ws/7d23fcbcf8cf42679552365d2ccff9a6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ae9546"]])

export default __exports__